<template>
	<div id="yuyue" v-if="loaded">
		<div class="form-group">
			<div class="form-line" v-on:click="addressPickerShow = true">
				<label>所在地区</label>
				<input placeholder="请选择" :value="address | pickerValueFilter" readonly/>
			</div>
			<div class="form-line" v-on:click="schoolPicker = true">
				<label>考场</label>
				<input type="text" :value="school[0].name" placeholder="请选择"/>
			</div>
			<div class="form-line" v-on:click="kemuPicker = true">
				<label>科目</label>
				<input type="text" :value="kemu | pickerValueFilter" placeholder="请选择"/>
			</div>
			<div class="form-line">
				<label>联系电话</label>
				<input type="number" v-model="phone" placeholder="请填写"/>
			</div>
			<div class="form-line">
				<label>真实姓名</label>
				<input type="text" v-model="realname" placeholder="请填写"/>
			</div>
			<div class="form-line">
				<label>预约时长</label>
				<input type="text" v-model="reserve_time_limit" placeholder="请填写"/>
			</div>
			<div class="form-line" v-on:click="openDatePicker">
				<label>预约时间</label>
				<input type="text" :value="reserve_time" placeholder="请填写" readonly/>
			</div>
			<div class="form-line">
				<label>备注</label>
				<textarea v-model="content" placeholder="如有其它要求，请填写"></textarea>
			</div>
		</div>
		<div class="btn" v-on:click="event_submit">
			确认预约
		</div>
		<wv-picker
		  :visible.sync="addressPickerShow"
		  v-model="region_change"
		  ref="addressPicker"
		  :columns="addressColumns"
		  :visible-item-count="5"
		  @change="onAddressChange"
		  @confirm="confirmAddress"
		/>
		<wv-picker
		  :visible.sync="kemuPicker"
		  :columns="kemuColumns"
		  v-model="kemu"
		  value-key="name"
		  @confirm="kemuConfirm"
		/>
		<wv-picker
		  :visible.sync="schoolPicker"
		  :columns="schoolColumns"
		  v-model="school_change"
		  value-key="name"
		  @confirm="schoolConfirm"
		/>
		<wv-datetime-picker
			ref="reservePicker"
			type="date"
			:start-date="reserveStartDate"
			@confirm="reserveConfirm"
			year-format="{value} 年"
			month-format="{value} 月"
			date-format="{value} 日"
			v-model="reserve_time_d">
		  </wv-datetime-picker>
	</div>
</template>

<script>

import chinaAreaData from 'china-area-data'
import { Toast } from 'we-vue'
const provinces = Object.values(chinaAreaData[86])
// 获取某一省下的市
const getCities = (province) => {
  let provinceCode
  for (let i in chinaAreaData[86]) {
    if (province === chinaAreaData[86][i]) {
      provinceCode = i
      break
    }
  }
  return typeof chinaAreaData[provinceCode] === 'object' ? Object.values(chinaAreaData[provinceCode]) : []
}
// 获取某一市下的区/县
function getAreas (province, city) {
  let provinceCode, cityCode
  for (let i in chinaAreaData[86]) {
    if (province === chinaAreaData[86][i]) {
      provinceCode = i
      break
    }
  }
  for (let i in chinaAreaData[provinceCode]) {
    if (city === chinaAreaData[provinceCode][i]) {
      cityCode = i
      break
    }
  }
  if (chinaAreaData[cityCode]) {
    return typeof chinaAreaData[cityCode] === 'object' ? Object.values(chinaAreaData[cityCode]) : []
  } else {
    // 只有两级的情况
    return []
  }
}
export default {
  data () {
    return {
		loaded:false,
		region_change:[],
		region:[],
		schoolPicker:false,
		addressPickerShow: false,
		kemu:['科目二'],
		phone:'',
		realname:'',
		content:'',
		address:[],
		school:[{value:0}],
		schoolColumns:[
			{
				values:[
					{
						name:'请选择',
						value:0
					}	
				]
			}
		],
		school_change:[{value:0}],
		kemuPicker:false,
		reserve_time:'',
		reserve_time_d:'',
		reserve_time_limit:'',
		reserveStartDate:(new Date()),
		kemuColumns:[
		  {
			values: ['科目二','科目三']
		  }
		],
		addressColumns: [
			{
				values: provinces
			},
			{
				values: getCities('云南省')
			},
			{
				values: getAreas('云南省', '昆明市')
			}
		]
	}
  },
  mounted () {
	this.$refs.addressPicker.setValues(['云南省','昆明市','五华区'])
	if(!this.$store.state.userInfo.driver_level.reserve){
		this.$wx.showToast('您没有发布车辆预约的权限')
		this.$router.push('/News')
	}
  },
  created(){
	this.loaded = true
  },
  methods: {
	openDatePicker(){
		this.$refs.reservePicker.open()
	},
	kemuConfirm(v,t){
		console.log(v);
	},
    onAddressChange (picker, addressValues, slotIndex) {
		if (slotIndex === 0) {
			const cities = getCities(addressValues[0])
			picker.setColumnValues(1, cities)
			picker.setColumnValues(2, getAreas(addressValues[0], cities[0]))
		} else if (slotIndex === 1) {
			picker.setColumnValues(2, getAreas(addressValues[0], addressValues[1]))
		}
		
	},
	reserveConfirm(picker){
		this.reserve_time = this.$dayjs(picker).format('YYYY-MM-DD')
	},
	confirmAddress (picker) {
		this.school_change = [{value:0}];
		this.school = [{value:0}];
		this.region_change = picker.getValues()
		this.address = picker.getValues()
		this.region = picker.getValues()
		//获取考场
		this.$app.pr('api/school/getschool',{
			address:this.address
		}).then((res) => {
			this.schoolColumns[0].values = [{
				name:'请选择',
				value:0
			}];
			for(var n in res.data){
				this.schoolColumns[0].values.push({
					name:res.data[n].subject,
					value:res.data[n].id
				});
			}
		});
	},
	schoolConfirm(picker){
		this.school = [];
		var pg = picker.getValues()
		for(var n in pg){
			this.school.push(pg[n])
		}
	},
	event_submit(){
		var that = this
		if (!this.address.length) {
		  this.$wx.showToast({
			title: '请选择您所在的地区',
			icon:'none'
		  });
		  return false;
		}

		if (!this.school[0].value) {
		  this.$wx.showToast({
			title: '请选择考场',
			icon:'none'
		  });
		  return false;
		}

		if (!this.kemu) {
		  this.$wx.showToast({
		title: '请选择科目',
		icon: 'none'
		  });
		  return false;
		}

		if (!/(13|14|15|16|17|18)[0-9]{9}/.test(this.phone)) {
		  this.$wx.showToast({
		title: '请输入正确的手机号码',
		icon: 'none'
		  });
		  return false;
		}

		if (!this.realname) {
		  this.$wx.showToast({
			title: '请输入真实姓名',
			icon: 'none'
		  });
		  return false;
		}

		if (this.reserve_time_limit == '') {
		  this.$wx.showToast({
			title: '请填写预约时长',
			icon: 'none'
		  });
		  return false;
		}

		if (this.reserve_time == '') {
		  this.$wx.showToast({
			title: '请选择预约时间',
			icon: 'none'
		  });
		  return false;
		}
		console.log({
			address:this.address,
			realname:this.realname,
			phone:this.phone,
			kemu:this.kemu,
			content:this.content
		});
		this.$app.pr('/api/reserve/add',{
			address:this.address.join('-'),
			school:this.school[0].value,
			realname:this.realname,
			phone:this.phone,
			kemu:this.kemu.join(''),
			reserve_time:this.reserve_time,
			content:this.content,
			reserve_time_limit:this.reserve_time_limit
		}).then((res) => {
			this.$wx.showToast(res.message);
			setTimeout(function(){
				that.$wx.navigateBack();
			},1000)
		}).catch((res) => {
			this.$wx.showToast(res)
		})
	}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#yuyue{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.form-group{
	}
	.form-group .form-line{
		width:100%;
		display:flex;
		display:-webkit-flex;
		background-color:#FFFFFF;
		padding:0px 3vw;
		margin:1.5vw 0vw;
	}
	.form-group .form-line label{
		display:inline-block;
		width:20vw;
		font-size:4.2vw;
		color:#898989;
		line-height:12vw;
	}
	.form-group .form-line input{
		height:12vw;
		border:0px;
		color:#5d5d5d;
		text-align:right;
		font-size:4vw;
	}
	.form-group .form-line textarea{
		height:20vw;
		border:0px;
		color:#5d5d5d;
		text-align:right;
		padding:5px 0px;
		line-height:7vw;
		font-size:4vw;
	}
	.form-group .form-line input,.form-group .form-line textarea{
		flex:1;
		-webkit-flex:1;
	}
	.btn{
		height:12vw;
		display:block;
		margin:5vw 3vw;
		text-align:center;
		color:#FFFFFF;
		background:linear-gradient(to right, #fa8d60, #e76025);
		font-size:4vw;
		line-height:12vw;
		border-radius:10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Yuyue.vue